export default __webpack_public_path__ + "static/media/AlyciaLovelace.fdb77e37.png";